import jsCookie from 'js-cookie';

import { isString } from './guards';

class Cookie {
  set(key: string, value: unknown): void {
    jsCookie.set(key, String(value), {
      path: '/support-chatbot',
      domain: 'wix.com',
      expires: 1 / 48, // in 30 minutes
    });
  }

  get(key: string): string | undefined {
    return jsCookie.get(key);
  }

  has(key: string): boolean {
    return isString(this.get(key));
  }

  is(key: string, value: string): boolean {
    return this.get(key) === value;
  }
}

export const cookie = new Cookie();
